/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_URL + "/api/user/",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("x-access-token", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getUser: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getUser",
      }),
    }),
    getUserById: builder.mutation({
      query: (userId) => ({
        method: "GET",
        url: `getUserById/${userId}`,
      }),
    }),
    deleteAgent: builder.mutation({
      query: (agentId) => ({
        body: { agentId },
        method: "DELETE",
        url: "deleteAgent",
      }),
    }),
    deleteUser: builder.mutation({
      query: (agentId) => ({
        body: { agentId },
        method: "DELETE",
        url: "deleteUser",
      }),
    }),
    blockAgent: builder.mutation({
      query: (agentId) => ({
        method: "PUT",
        url: `blockAgent/${agentId}`,
      }),
    }),
    blockUser: builder.mutation({
      query: (agentId) => ({
        method: "PUT",
        url: `blockUser/${agentId}`,
      }),
    }),
    updateUser: builder.mutation({
      query: ({ email, numero, username }) => ({
        body: { email, numero, username },
        method: "PUT",
        url: "updateUser",
      }),
    }),
    updateUserByAdmin: builder.mutation({
      query: (userId, { email, numero, username }) => ({
        params: { userId },
        body: { email, numero, username },
        method: "PUT",
        url: `updateUser/${userId}`,
      }),
    }),

    getAgents: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getAgents",
      }),
    }),
    getResponsable: builder.mutation({
      query: (data) => ({
        method: "GET",
        url: "getResponsable",
      }),
    }),
    getAllUsers: builder.mutation({
      query: (data) => ({
        method: "GET",
        url: "getAllUsers",
      }),
    }),
    selectedMode: builder.mutation({
      query: (mode) => ({
        body: { mode },
        method: "POST",
        url: "selectedMode",
      }),
    }),
    getResponsableBalance: builder.query({
      query: () => ({
        method: "GET",
        url: `getResponsableTokens`,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUserMutation,
  useGetUserByIdMutation,
  useBlockUserMutation,
  useDeleteAgentMutation,
  useBlockAgentMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useUpdateUserByAdminMutation,
  useGetAgentsMutation,
  useGetAllUsersMutation,
  useGetResponsableMutation,
  useSelectedModeMutation,
  useGetResponsableBalanceQuery,
} = userApi;
